export enum ErrorHeaders {
  SkipGenericErrorHandling = "X-LMW-Skip-Client-Error-Handler"
}
